module.exports = __webpack_public_path__ + "static/qh_28.f72c9d4a.jpg";